// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6f093c59","259":"8f99a2d4","369":"db77eeef","656":"ab843b9c","734":"30d8a9ba","787":"4c6a7659","968":"13431d0e"}[chunkId] + ".chunk.js";
};